<template>
	<div v-for="invitation in invitations" :key="invitation.id" class="d-flex align-center">
		<div class="d-flex gap-2 align-center">
			<Avatar :src="guestAvatar" height="32px" width="32px" />
			<div class="text-neutral-600 text-body-m">
				<p :class="isXS ? 'email-mobile' : ''" :title="invitation.email">
					{{ invitation.email }}
				</p>
				<p>({{ $t('web.trip.invite.email.sent') }})</p>
			</div>
		</div>
		<TripGuestOptions
			class="more-button"
			@resend="resendInvitation(invitation)"
			@remove="removeInvitation(invitation)"
		/>
	</div>
</template>

<script setup lang="ts">
	import guestAvatar from '~/assets/guest-avatar.png'
	import { TripInvitation } from '~/models/TripInvitation'

	interface Props {
		invitations: TripInvitation[]
		isXS: boolean
	}
	interface Emits {
		(e: 'resend', email: string): void
		(e: 'cancel', invitationId: string): void
	}
	defineProps<Props>()
	const emit = defineEmits<Emits>()

	const resendInvitation = (invitation: TripInvitation) => {
		emit('resend', invitation.email!)
	}

	const removeInvitation = (invitation: TripInvitation) => {
		emit('cancel', invitation.id)
	}
</script>
<style scoped lang="scss">
	.more-button {
		margin-left: auto;
	}
	.email-mobile {
		max-width: calc(100vw - 130px);
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
</style>
